"use client"

import { SquareScissors } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SquareScissorsIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SquareScissorsIcon = component(Icon)({ as: SquareScissors })
